import { render, staticRenderFns } from "./DrawerComponent.vue?vue&type=template&id=3f650208&"
import script from "./DrawerComponent.vue?vue&type=script&lang=js&"
export * from "./DrawerComponent.vue?vue&type=script&lang=js&"
import style0 from "./DrawerComponent.vue?vue&type=style&index=0&id=3f650208&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports